import React from 'react'
import { DatePickerControl } from './date-picker'
import { TimePickerControl } from './time-picker'

export interface DateTimePickerProps {
  dateTime: Date
  updateDate: (date: Date) => void
  showDate?: boolean
  showTime?: boolean
}

/**
 * DateTimePicker component for selecting both date and time.
 * Can be used independently or within forms.
 *
 * @param dateTime - Current date/time value
 * @param updateDate - Callback when date/time changes
 * @param showDate - Show date picker (default: true)
 * @param showTime - Show time picker (default: true)
 */
export const DateTimePicker = ({
  updateDate,
  dateTime,
  showDate = true,
  showTime = true,
}: DateTimePickerProps) => {
  return (
    <div className="flex gap-3">
      {showDate && (
        <DatePickerControl dateTime={dateTime} updateDate={updateDate} />
      )}
      {showTime && (
        <TimePickerControl
          dateTime={dateTime}
          updateDate={updateDate}
          showDate={showDate}
        />
      )}
    </div>
  )
}

export { DatePickerControl, TimePickerControl }
